export default {
    attrs: {
        centered: true,
        grow: true,
        dark: true
    }
}
